import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { ReactComponent as HackIcon } from '../../assets/img/hack-icon.svg';
import { fontDisplay, fontUi, pill } from '../../theme/typography';

export const StyledContainer = styled.section`
  grid-area: next;
  min-width: 0;
  width: 100%;
  @media only screen and (max-width: 1199px) {
    width: 100%;
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const StyledTypePill = styled.span`
  ${pill};
  padding: 6px 12px;
  font-size: 11px;
  font-weight: 600;
  background: ${({ theme }) => (theme.isDark ? theme.hover : '#111')};
  color: #fff;
`;

export const StyledNextMatch = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding-top: 0;
  min-height: 268px;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

  @media only screen and (max-width: 1199px) {
    min-height: 280px;
    width: 100%;
  }
`;

export const StyledNextMatchInner = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1;
  border-radius: ${({ theme }) => theme.cardRadius};
  overflow: hidden;
  padding: 20px 12px 12px;
  background: ${({ $live, theme }) =>
    $live ? (theme.isDark ? theme.page : '#050d0a') : '#06170d'};
  border: ${({ $live, theme }) =>
    $live
      ? `1.5px solid ${theme.headerAccent}`
      : '1px solid rgba(180, 210, 186, 0.32)'};
  box-shadow: 0 8px 22px rgba(6, 23, 13, 0.28);
`;

export const StyledDatePill = styled.span`
  ${pill};
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  padding: ${({ $live }) => ($live ? '7px 14px' : '6px 12px')};
  font-size: ${({ $live }) => ($live ? '12px' : '11px')};
  font-weight: ${({ $live }) => ($live ? 700 : 500)};
  background: ${({ $live, theme }) =>
    $live ? theme.headerAccent : '#eceee9'};
  color: #2a2a2a;
  border-radius: ${({ $live }) => ($live ? '8px' : '6px')};
`;

export const StyledKitsRow = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  gap: 0;
  width: 100%;
  margin-top: 2px;
  flex: 1;
`;

export const StyledKitSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
  flex: 1;
`;

export const StyledKitStage = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 168px;
  height: 158px;
  overflow: visible;
  img:last-of-type {
    width: 118px !important;
    max-width: 118px !important;
    height: auto !important;
    max-height: 138px !important;
    position: relative !important;
    top: auto !important;
    right: auto !important;
    left: auto !important;
    bottom: auto !important;
    margin: 0 !important;
    z-index: 1;
    filter: drop-shadow(0 8px 12px rgba(0, 0, 0, 0.45));
  }
`;

export const StyledCrestFade = styled.img`
  position: absolute !important;
  top: -44px !important;
  bottom: auto !important;
  left: ${({ $side }) => ($side === 'away' ? 'auto' : '-48px')} !important;
  right: ${({ $side }) => ($side === 'away' ? '-48px' : 'auto')} !important;
  width: 188px !important;
  height: 188px !important;
  max-width: none !important;
  max-height: none !important;
  transform: none;
  object-fit: contain;
  opacity: 0.7;
  pointer-events: none;
  z-index: 0 !important;
  margin: 0 !important;
  -webkit-mask-image: ${({ $side }) =>
    $side === 'away'
      ? 'linear-gradient(to bottom left, #000 18%, rgba(0, 0, 0, 0.75) 48%, transparent 86%)'
      : 'linear-gradient(to bottom right, #000 18%, rgba(0, 0, 0, 0.75) 48%, transparent 86%)'};
  mask-image: ${({ $side }) =>
    $side === 'away'
      ? 'linear-gradient(to bottom left, #000 18%, rgba(0, 0, 0, 0.75) 48%, transparent 86%)'
      : 'linear-gradient(to bottom right, #000 18%, rgba(0, 0, 0, 0.75) 48%, transparent 86%)'};
`;

export const StyledKitName = styled.span`
  ${fontUi};
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
  text-align: ${({ $side }) => ($side === 'away' ? 'right' : 'left')};
  margin-top: 8px;
  width: 100%;
  max-width: none;
  padding: ${({ $side }) => ($side === 'away' ? '0 2px 0 12px' : '0 12px 0 2px')};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const StyledVs = styled.span`
  ${fontUi};
  position: absolute;
  left: 50%;
  top: 38%;
  transform: translate(-50%, -50%);
  z-index: 2;
  color: ${({ $live, theme }) =>
    $live ? theme.headerAccent : '#6eb87a'};
  font-size: ${({ $live }) => ($live ? '22px' : '28px')};
  font-weight: 700;
  line-height: 1;
  width: auto;
  padding: 0;
  pointer-events: none;
`;

export const StyledLiveScore = styled.div`
  appearance: none;
  border: 0;
  background: transparent;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  position: absolute;
  left: 50%;
  top: 38%;
  transform: translate(-50%, -50%);
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  pointer-events: ${({ $clickable }) => ($clickable ? 'auto' : 'none')};

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.headerAccent};
    outline-offset: 4px;
    border-radius: 4px;
  }
`;

export const StyledLiveGoal = styled.span`
  ${fontDisplay};
  color: #fff;
  font-size: 34px;
  letter-spacing: -0.03em;
  line-height: 1;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.55);
`;

export const StyledLiveX = styled.span`
  ${fontUi};
  color: ${({ theme }) => theme.headerAccent};
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
  padding-bottom: 2px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.45);
`;

export const StyledEmpty = styled.p`
  ${fontDisplay};
  position: relative;
  z-index: 1;
  color: #fff;
  font-size: 20px;
  text-align: center;
  margin: 40px 0 24px;
`;

export const StyledLink = styled(Link)`
  ${pill};
  position: relative;
  z-index: 1;
  margin: 12px 0 0;
  padding: 12px 20px;
  min-height: 44px;
  width: 100%;
  max-width: none;
  background: transparent;
  border: 1.5px solid rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0;
  text-decoration: none;
  box-shadow: none;
`;

export const StyledInGame = styled(Link)`
  ${pill};
  position: relative;
  z-index: 1;
  margin: ${({ $live }) => ($live ? '12px 0 0' : '8px 0 0')};
  padding: 12px 20px;
  min-height: ${({ $live }) => ($live ? '48px' : '40px')};
  width: ${({ $live }) => ($live ? '100%' : 'auto')};
  background: ${({ $live, theme }) =>
    $live ? theme.headerAccent : '#fff'};
  border-radius: ${({ $live, theme }) =>
    $live ? theme.cardRadius : theme.controlRadius};
  color: #000;
  font-weight: ${({ $live }) => ($live ? 700 : 500)};
  font-size: ${({ $live }) => ($live ? '14px' : '13px')};
  text-decoration: none;
`;

export const StyledNewLabel = styled.span`
  ${pill};
  position: absolute;
  right: -6px;
  top: -8px;
  height: 18px;
  padding: 0 7px;
  background-color: #000;
  color: #fff;
  font-size: 9px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

export const StyledHackIcon = styled(HackIcon)`
  width: 18px;
  height: 18px;
  margin-right: 5px;
`;

export const StyledButton = styled.button`
  ${pill};
  height: 38px;
  margin: 12px 5px 0;
  position: relative;
  z-index: 1;
  padding: 9px 20px;
  font-size: 13px;
  background-color: #e94235;
  border: 1px solid #e94235;
  color: #fff;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  &:disabled {
    background-color: #ebebeb;
    color: #989898;
    border: 1px solid #ebebeb;
  }
`;

export const StyledButtonsContainer = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  ${({ $live }) =>
    !$live &&
    `
    @media only screen and (min-width: 769px) and (max-width: 1199px) {
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 12px;
    }
  `}
`;

export const StyledFallbackContainer = styled.div`
  position: relative;
  min-height: 260px;
  border-radius: ${({ theme }) => theme.cardRadius};
  background: #06170d;
  overflow: hidden;
`;

export const StyledLockers = styled.img`
  display: none;
`;

export const StyledNextMatchBg = styled.img`
  display: none;
`;

export const StyledTeamShirtContainer = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const StyledShirtImg = styled.div`
  img,
  & {
    position: relative !important;
    top: auto !important;
    right: auto !important;
    left: auto !important;
    bottom: auto !important;
    width: 88px !important;
    height: auto !important;
    max-height: 110px !important;
    margin: 0 !important;
  }
`;
